'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _models = require('./models');

var _models2 = _interopRequireDefault(_models);

var _actions = require('./actions');

var _actions2 = _interopRequireDefault(_actions);

var _api = require('signer/api');

var _api2 = _interopRequireDefault(_api);

var _endpoints = require('signer/api/endpoints');

var _endpoints2 = _interopRequireDefault(_endpoints);

var _endpoints3 = require('./api/endpoints');

var _endpoints4 = _interopRequireDefault(_endpoints3);

var _application = require('common/application');

var _application2 = _interopRequireDefault(_application);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

try {
    require('babel-polyfill');
} catch (e) {/* fix error where only one polyfill is allowed */}

require("intl"); // needed for react intl otherwise stuff busts

function Application(properties) {
    _application2['default'].call(this, _extends({}, properties));

    this.models = _models2['default'];

    this.notifier = this.notifierCollection;

    // set data here to prevent undefined exceptions in api/endpoints
    this.serverSideGeneratedData = {};

    this.actions = _actions2['default'].create({ app: this });

    // the API service is added as a global notifier so that any
    // part of the application can implicitly execute a message to the API
    // service and receive a response.
    // I.E: the API service is decoupled from the APP.
    // I.E: the app is more testable.
    this.notifier.push(_api2['default'].create({

        // attach notifier so that the API service can announce
        // when there is a response from the service
        notifier: this.notifier,

        // combine both endpoints
        endpoints: Object.assign(_endpoints2['default'].create(this), _endpoints4['default'].create(this))
    }));

    this.user = _models2['default'].User.create({
        notifier: this.notifier
    });
}

_application2['default'].extend(Application, {
    hydrate: function hydrate(data) {

        // this stuff should be an API at some point
        this.serverSideGeneratedData = data;
    }
});

module.exports = Application;

Application.components = require('./components');
Application.mixins = {
    'AdjustScrollingMixin': require('./components/api-docs/api-menu/adjust-scrolling-mixin')
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/application.js
 ** module id = 573
 ** module chunks = 0
 **/